module.exports = __webpack_public_path__ + "media/images/shared/suppliers/HOLSET-9bcbf0388100e5a981d857f0d67735a2.jpg";